import { useTranslation } from 'react-i18next'

import Text from '../../Text'
import { useEpostFormContext } from '../Epost.hooks'

import * as styles from './EpostFormCalculateLoader.module.css'

function EpostFormCalculateLoader() {
  const { t } = useTranslation()

  const { calculateLoadingPercent } = useEpostFormContext()

  return (
    <div className={styles.EpostFormCalculateLoader}>
      <Text className={styles.text}>
        {t('Epost.CalculatingProgressTextKey', {
          count: Math.ceil(calculateLoadingPercent),
        })}
      </Text>
      <span
        className={styles.loader}
        style={{
          '--epost-calculate-loading-percent': calculateLoadingPercent,
        }}
      />
    </div>
  )
}

export default EpostFormCalculateLoader
